import styled from 'styled-components';
import { Colors } from 'modules/theme';

const FLOW_VOLUME_CONTENT_MAX = '600px';

export const DateRangeButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1px solid #d7e6f2;
  background: #fff;
  color: ${Colors.lightBlue};
  border-radius: 999px;
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 500;
  font-family: Inter, sans-serif;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    border-color: ${Colors.lightBlue};
    background: #eef7fd;
  }
`;

export const ChartPanel = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  min-width: 0;
  background: #f8fbff;
  border: 1px solid #e8f1f8;
  border-radius: 12px;
  padding: 12px 8px 8px;
  box-sizing: border-box;
`;

export const ChartSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ChartViewport = styled.div`
  width: 100%;
  max-width: ${FLOW_VOLUME_CONTENT_MAX};
  height: 300px;
  min-width: 0;
  margin: 0 auto;
`;

export const ChartViewportFull = styled(ChartViewport)`
  max-width: none;
  margin: 0;
`;

export const ChartMeta = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 4px;
  flex-shrink: 0;
`;

export const LastUpdatedBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 14px;
  border-radius: 999px;
  background: #fff;
  border: 1px solid #e8f1f8;
  font-size: 12px;
  color: #64748b;
  font-family: Inter, sans-serif;
  line-height: 1.4;
`;

export const LastUpdatedLabel = styled.span`
  font-weight: 500;
  color: #94a3b8;
`;

export const LastUpdatedValue = styled.span`
  font-weight: 600;
  color: ${Colors.gray8};
`;

export const LastUpdatedDot = styled.span`
  color: #cbd5e1;
  font-weight: 400;
`;

export const StatsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(200px, 1fr));
  gap: 16px;
  width: 100%;
  max-width: ${FLOW_VOLUME_CONTENT_MAX};
  margin: 12px auto 0;
  flex-shrink: 0;
`;

export const StatCard = styled.div`
  min-height: 95px;
  width: 100%;
  padding: 16px;
  background: #f8fbff;
  border-radius: 12px;
  border: 1px solid #e8f1f8;
  box-sizing: border-box;
  transition: box-shadow 0.15s ease;

  &:hover {
    box-shadow: 0 4px 14px rgba(20, 152, 203, 0.08);
  }
`;

export const StatLabel = styled.div`
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: ${Colors.blue};
  font-family: Inter, sans-serif;
`;

export const StatValue = styled.span`
  font-size: 28px;
  font-weight: 600;
  color: ${Colors.lightBlue};
  font-family: Inter, sans-serif;
`;

export const StatUnit = styled.span`
  color: #4a5568;
  margin-left: 5px;
  font-size: 16px;
  font-weight: 500;
`;

export const IntervalBadge = styled.span`
  display: inline-flex;
  align-items: center;
  border: 1px solid #d7e6f2;
  background: #fff;
  color: #4a5568;
  border-radius: 999px;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 500;
  font-family: Inter, sans-serif;
  margin-right: 8px;
`;
